{
  "title": "Idag",
  "subscription_required": "En aktiv prenumeration krävs för att starta övningen.",
  "weekly_exercise_section": "Veckoövning",
  "collapse_daily_tip": "Dölj dagens tips",
  "show_daily_tip": "Visa dagens tips",
  "daily_warmup_title_pending": "Det är dags för din dagliga uppvärmning!",
  "daily_warmup_title_completed": "Dagliga uppvärmningar",
  "daily_warmup_error_title": "Uppvärmningen är inte tillgänglig",
  "daily_warmup_error_message": "Vi kunde inte ladda dina framsteg. Försök igen, eller fortsätt med dina andra övningar.",
  "measurement_reminder_title": "Starta röstmätning",
  "measurement_reminder_duration": "Hur lång tid tar det? - {{duration}}",
  "measurement_reminder_error_title": "Röstmätningen är inte tillgänglig",
  "measurement_reminder_error_message": "Vi kunde inte ladda din röstmätning. Försök igen, eller fortsätt med dina andra övningar.",
  "weekly_exercises_error_title": "Veckoövningen är inte tillgänglig",
  "weekly_exercises_error_message": "Vi kunde inte ladda dina veckoövningar. Försök igen, eller kontakta support om problemet kvarstår.",
  "weekly_exercises_empty_title": "Inga övningar denna vecka",
  "weekly_exercises_empty_message": "Det finns inga schemalagda övningar för den här veckan. Prova att välja en annan vecka.",
  "minutes_short": "min",
  "week_picker_go_to_today": "Idag",
  "week_n": "Vecka {{week}}",
  "weekly_widget_exercises_label": "Övningar",
  "weekly_widget_exercise_goal_label": "Träningsmål",
  "weekly_widget_streak_label": "Streak",
  "weekly_widget_exercises_value_completed": "{{count}} slutförda",
  "weekly_widget_exercise_goal_value_one": "{{count}} övning",
  "weekly_widget_exercise_goal_value_other": "{{count}} övningar",
  "weekly_widget_streak_value_one": "{{count}} vecka",
  "weekly_widget_streak_value_other": "{{count}} veckor",
  "weekly_widget_error_title": "Veckoframstegen är inte tillgängliga",
  "weekly_widget_error_message": "Vi kunde inte ladda dina veckoframsteg. Försök igen, eller fortsätt med dagens övningar."
}
